<template>
  <section class="banner-container">
    <carousel
      v-if="banners.length > 0"
      :autoplay="true"
      :nav="true"
      :items="1"
      :loop="true"
      :dots="false"
    >
      <img
        v-for="banner in banners"
        v-bind:key="banner.id"
        :src="(banners.length < 1) ? require('../../assets/banner/1.jpg') : JSON.parse(banner.meta).meta_picture"
      />
    </carousel>
    <div v-if="show_loading" class="banner-loader">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </div>

    <div v-if="banners.length < 1 && !show_loading" style="padding: 15px;">
      <div class="alert alert-danger" style="margin-bottom: 250px;">Tidak ada data banner</div>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
import api from "../../services/api";

export default {
  components: { carousel },
  data() {
    return {
      show_loading: false,
      banners: [],
    };
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    getBanner() {
      this.show_loading = true;
      api
        .post(api.route.get.banner)
        .then((res) => {
          let status = res.status;
          if (status) this.banners = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.banner-loader {
  text-align: center;
  padding: 250px 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/HomeBanner.vue